module.exports = __webpack_public_path__ + "static/media/ladyCharacter.ae2feaf9.jpg";